// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2FBrT","tab":"ProcedureTabs_tab__g1-CA"};